var map = {
	"./NULL.svg": "dee2",
	"./delete.svg": "0d45",
	"./label.svg": "765c",
	"./left.svg": "2b80",
	"./money.svg": "cf44",
	"./moneyNumPad.svg": "43df",
	"./right.svg": "37af",
	"./rili.svg": "0f60",
	"./statistics.svg": "8ccb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b422";